import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import '../PremiumPricing/styles.scss'
import images from '../../Utils/images';
import data from '../PremiumPricing/Components/TableData.json';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import PremiumModal from '../CreatorNew/Components/PremiumModal';
import { useNavigate } from 'react-router-dom';
import PricingComparisonTable from './Components/PricingComparisionTable';
import colors from '../../Utils/colors';

export const FeatureItem = ({ item, currency, planDuration, seeDetails = false, seeDetailsAction, setShowPremiumModal, setSelectedPlan, }) => {

    const localdata = useSelector((state) => state.main.localdata);

    const buttonText = localdata?.premiumPlanName && (item?.name === localdata?.premiumPlanName && planDuration === localdata?.premium_details?.plan_type && currency === localdata?.premium_details?.currency) ? 'Current Active Plan' : (seeDetails ? 'See Details' : 'Purchase plan');

    const itemColor = colors.white01;

    const itemPrice =
        currency == 'INR' && planDuration == 'Quarterly' ? item.priceINR[0] :
            currency == 'INR' && planDuration == 'Half-Yearly' ? item.priceINR[1] :
                currency == 'INR' && planDuration == 'Yearly' ? item.priceINR[2] :
                    currency == 'USD' && planDuration == 'Quarterly' ? item.priceUSD[0] :
                        currency == 'USD' && planDuration == 'Half-Yearly' ? item.priceUSD[1] :
                            currency == 'USD' && planDuration == 'Yearly' && item.priceUSD[2];

    const planName = item?.name;

    const itemPricePerMonth =
        currency == 'INR' && planDuration == 'Quarterly' ? item.pricePerMonthINR[0] :
            currency == 'INR' && planDuration == 'Half-Yearly' ? item.pricePerMonthINR[1] :
                currency == 'INR' && planDuration == 'Yearly' ? item.pricePerMonthINR[2] :
                    currency == 'USD' && planDuration == 'Quarterly' ? item.pricePerMonthUSD[0] :
                        currency == 'USD' && planDuration == 'Half-Yearly' ? item.pricePerMonthUSD[1] :
                            currency == 'USD' && planDuration == 'Yearly' && item.pricePerMonthUSD[2];

    const purchasePlansAction = () => {
        setSelectedPlan({
            planName: item.name,
            planDuration: planDuration,
            currency: currency
        });
        setShowPremiumModal(true);
    }



 return (
        <>
            <div className='feature_item_container' style={{border:`1px solid ${colors.borderwhite}`,borderRadius:12,backgroundColor:"#FAFCFC"}}>
                <div className='feature_item' style={{ backgroundColor: "#FAFCFC" }}>
                    <p className='font16' style={{ fontWeight: 700 }}>
                        {item.name}
                    </p>
                    <p style={{color:colors.greys04}}>
                        {item?.text}
                    </p>
                    <p className='font20' style={{ marginBlockEnd: 8, marginBlockStart: 8, fontWeight: 700 }}>
                        {`${currency === 'INR' ? '₹' : '$'}${itemPricePerMonth}`}
                        <span className='font14' style={{ fontSize: 12 }}>
                            {`/month`}
                        </span>
                    </p>
                    <p className='' style={{ marginBlockEnd: 16, fontWeight: 500,color:colors.greys04 }}>
                        {`${itemPrice}`}
                    </p>
                    <p className='font14' style={{ width: '100%', fontWeight:600 }}>
                        {`Includes ${planName == 'Startup' ? '3000' : planName == 'Growth' ? '10,000' : planName == 'Pro' && '25,000'} Automation Tasks/month`}
                    </p>
                    <div className='custom_button' style={{ width: '100%', marginBlockStart: 16, borderColor: 'white', marginInline: 0 }} onClick={() => {
                        if (seeDetails) {
                            seeDetailsAction();
                        } else if (localdata?.premium === false || (item?.name !== localdata?.premiumPlanName || planDuration !== localdata?.premium_details?.plan_type || currency !== localdata?.premium_details?.currency)) {
                            purchasePlansAction();
                        }
                    }}>
                        <p className='font14' style={{ color: itemColor }}>
                            {buttonText}
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}


export const PlanDetails = [
    // {
    //     name: "Basic",
    //     priceINR: ['4,500', '7,500', '12,000'],
    //     priceUSD: ['56', '94', '150'],
    //     INRID: ['plan_OyCNaABf59WSMO', 'plan_OyCTRCXBKTIvg0', 'plan_OyCXxb0OQKcuF2'],
    //     USDID: ['plan_OSAQhGj7slsjPf', 'plan_OTJfFLMqpOMMQW', 'plan_OTK3czSgCcIbtT'],
    // },
    {
        name: "Startup",
        text: "Ideal for early-stage teams looking to kickstart omni-channel automation without the complexity.",
        pricePerMonthINR: ['2,999','2,499','1,999'],
        pricePerMonthUSD: ['34','28','23'],
        priceINR: ['Billed Quarterly (+taxes)', 'Billed Half-Yearly (+taxes)', 'Billed Yearly (+taxes)'],
        priceUSD: ['Billed Quarterly (+taxes)', 'Billed Half-Yearly (+taxes)', 'Billed Yearly (+taxes)'],
        INRID: ['plan_RCcWgSsBbQNq8z', 'plan_RCcWcUW2c0YTqR', 'plan_RCcWYGLTVGVr3V'],
        USDID: ['plan_RCcWhjAlwTWb4g', 'plan_RCcWd4CY3bJGpQ', 'plan_RCcWYuLMHvUP83'],
    },
    {
        name: "Growth", 
        text: "Designed for scaling teams who want to automate, optimize, and grow across multiple marketing channels.",
        pricePerMonthINR: ['7,999','5,999','4,999'],
        pricePerMonthUSD: ['92','69','57'],
        priceINR: ['Billed Quarterly (+taxes)', 'Billed Half-Yearly (+taxes)', 'Billed Yearly (+taxes)'],
        priceUSD: ['Billed Quarterly (+taxes)', 'Billed Half-Yearly (+taxes)', 'Billed Yearly (+taxes)'],
        INRID: ['plan_RCcWiPnGg8RMeF', 'plan_RCcWderqAGY0gG', 'plan_RCcWZdMRFVboPl'],
        USDID: ['plan_RCcWj1rIwvmwGV', 'plan_RCcWeH7s3CrrwO', 'plan_RCcWaP9V0zBm5c'],
    },
    {
        name: "Pro", 
        text: "Built for advanced teams running complex omni-channel strategies with maximum scale and precision",
        pricePerMonthINR: ['13,999','11,999','9,999'],
        pricePerMonthUSD: ['161','139','115'],
        priceINR: ['Billed Quarterly (+taxes)', 'Billed Half-Yearly (+taxes)', 'Billed Yearly (+taxes)'],
        priceUSD: ['Billed Quarterly (+taxes)', 'Billed Half-Yearly (+taxes)', 'Billed Yearly (+taxes)'],
        INRID: ['plan_RCcWjgOW1X4Qpa', 'plan_RCcWexzUKfrF2C', 'plan_RCcWb58fcIoiQ0'],
        USDID: ['plan_RCcWkHfgllh9G4', 'plan_RCcWfbIHJ0B0sz', 'plan_RCcWbq7o6uSlE2'],
    }
    // {
    //     name: "Enterprise",
    //     duration: "Quarterly",
    //     priceINR: ['70,000', '120,000', '200,000'],
    //     priceUSD: ['875', '1,500', '2,500'],
    //     INRID: ['plan_OyCRqbjVLaR3QG', 'plan_OyCWsK02DtUGGj', 'plan_OyCc4AbjOyMslf'],
    //     USDID: ['plan_OSAVJLbMULJTU4', 'plan_OTJvKy4q6aMBqm', 'plan_OTKBhayTDmzmth'],
    // }
]

const PremiumPricing = () => {
    const [showPremiumModal, setShowPremiumModal] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [planDuration, setPlanDuration] = useState('Quarterly');
    const [currency, setCurrency] = useState('INR');
    const navigate = useNavigate();

    return (

        <>
            {showPremiumModal && selectedPlan && (
                <PremiumModal
                    setShowPremiumModal={setShowPremiumModal}
                    showPremiumModal={showPremiumModal}
                    planName={selectedPlan.planName}
                    planDuration={selectedPlan.planDuration}
                    currency={selectedPlan.currency}
                />
            )}
            <div className="premium_navbar" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 20px',
                // borderBottom: '1px solid #E0E0E0',
                backgroundColor: '#FFFFFF'
            }}>
                <div className="nav_left" style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src={images.BackArrowBlack}
                        alt="back"
                        style={{ marginRight: 10, cursor: 'pointer', width: '32px', height: '32px' }}
                        onClick={() => {
                            navigate('/creator')
                        }}
                    />
                    <p style={{ fontSize: 20, fontWeight: 700 }}>Upgrade to Cheerio Premium</p>
                </div>
            </div>

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: '6%',
                    alignItems: 'center',
                    textAlign: 'center',
                    flexDirection: 'column',
                    rowGap:'16px',
                    marginBlockEnd:'36px'
                }}
            >
                <h2

                >
                    Upgrade for more benefits
                </h2>
                <p style={{fontSize:20}}>
                    More features, More growth
                </p>
            </div>
            {/* Selectors */}
            <div className='pricing_selector_container'>

                {/* Duration */}
                <div className='Row' style={{ justifyContent: 'center', marginInline: 16 }}>
                    <div
                        className={`pricing_button ${planDuration === 'Quarterly' ? 'pb_selected' : 'pb_unselected'} pb_left`}
                        onClick={() => {
                            setPlanDuration('Quarterly')
                        }}
                    >
                        <p className={`font16 ${planDuration === 'Quarterly' ? 'white01' : 'black01'}`}>
                            {'Quarterly'}
                        </p>
                    </div>
                    <div
                        className={`pricing_button ${planDuration === 'Half-Yearly' ? 'pb_selected' : 'pb_unselected'}`}
                        onClick={() => {
                            setPlanDuration('Half-Yearly')
                        }}
                    >
                        <div className='Row' style={{ justifyContent: 'center' }}>
                            <p className={`font16 ${planDuration === 'Half-Yearly' ? 'white01' : 'black01'}`}>
                                {'Half-Yearly '}
                            </p>
                            {/* <span className='off_span'>
                                {'8% off'}
                            </span> */}
                        </div>
                    </div>
                    <div
                        className={`pricing_button ${planDuration === 'Yearly' ? 'pb_selected' : 'pb_unselected'} pb_right`}
                        onClick={() => {
                            setPlanDuration('Yearly')
                        }}
                    >
                        <div className='Row' style={{ justifyContent: 'center' }}>
                            <p className={`font16 ${planDuration === 'Yearly' ? 'white01' : 'black01'}`}>
                                {'Yearly'}
                            </p>
                            {/* <span className='off_span'>
                                {'20% off'}
                            </span> */}
                        </div>
                    </div>
                </div>

                {/* Currency */}
                <div className='Row' style={{ justifyContent: 'center', marginInline: 16 }}>
                    <div
                        className={`pricing_button ${currency === 'INR' ? 'pb_selected' : 'pb_unselected'} pb_left`}
                        onClick={() => {
                            setCurrency('INR')
                        }}
                    >
                        <div className='Row' style={{ justifyContent: 'center' }}>
                            <p className={`font16 ${currency === 'INR' ? 'white01' : 'black01'}`}>
                                {'INR'}
                            </p>
                            <img src={images.FlagIndia} style={{
                                height: 12, width: 12, objectFit: 'contain', marginInlineStart: 6
                            }}></img>
                        </div>
                    </div>
                    <div
                        className={`pricing_button ${currency === 'USD' ? 'pb_selected' : 'pb_unselected'} pb_right`}
                        onClick={() => {
                            setCurrency('USD')
                        }}
                    >
                        <div className='Row' style={{ justifyContent: 'center' }}>
                            <p className={`font16 ${currency === 'USD' ? 'white01' : 'black01'}`}>
                                {'USD'}
                            </p>
                            <img src={images.FlagUSA} style={{
                                height: 12, width: 12, objectFit: 'contain', marginInlineStart: 6
                            }}></img>
                        </div>
                    </div>
                </div>
            </div>

            {/* Features Strip */}
            <div className='feature_strip_container px-4' style={{columnGap:24}}>
                {/* <div className='feature_item_container'>
                    <div className='feature_item'>
                        <p className='font18 black01'>
                            {'Features'}
                        </p>
                    </div>
                </div> */}
                {PlanDetails.map((item, index) => {
                    return (
                        <FeatureItem item={item} currency={currency} planDuration={planDuration} seeDetailsAction={() => { }} setShowPremiumModal={setShowPremiumModal}
                            setSelectedPlan={setSelectedPlan} />
                    )
                })}
            </div>


            {/* Table */}
            {/* <Table style={{ marginBlock: 16 }}>
                <TableBody>
                    {data.slice(0, 5).map((row) => {
                        return (
                            <TableRow style={{ backgroundColor: 'white', paddingInline: 8 }}>
                                <TableCell style={{ width: '16%', border: 'none' }} align='left'>{row.feature}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{currency == 'USD' ? 'Regional Pricing' : row.basic}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{currency == 'USD' ? 'Regional Pricing' : row.startup}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{currency == 'USD' ? 'Regional Pricing' : row.growth}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{currency == 'USD' ? 'Regional Pricing' : row.pro}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{currency == 'USD' ? 'Regional Pricing' : row.enterprise}</TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
            <Table style={{ marginBlock: 16 }}>
                <TableBody>
                    {data.slice(5, 17).map((row) => {
                        return (
                            <TableRow style={{ backgroundColor: 'white' }}>
                                <TableCell style={{ width: '16%', border: 'none', }} align='left'>{row.feature}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.basic}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.startup}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.growth}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.pro}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.enterprise}</TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
            <Table style={{ marginBlock: 16 }}>
                <TableBody>
                    {data.slice(17, 22).map((row) => {
                        return (
                            <TableRow style={{ backgroundColor: 'white' }}>
                                <TableCell style={{ width: '16%', border: 'none', }} align='left'>{row.feature}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.basic}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.startup}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.growth}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.pro}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.enterprise}</TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
            <Table style={{ marginBlock: 16 }}>
                <TableBody>
                    {data.slice(22, 27).map((row) => {
                        return (
                            <TableRow style={{ backgroundColor: 'white' }}>
                                <TableCell style={{ width: '16%', border: 'none', }} align='left'>{row.feature}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.basic}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.startup}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.growth}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.pro}</TableCell>
                                <TableCell style={{ width: '16%', border: 'none', }} align='center'>{row.enterprise}</TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table> */}
            <div className='Column w-100 py-2 px-3'>
                <PricingComparisonTable />
            </div>
        </>
    )
}

export default PremiumPricing